import React, { useEffect, useState } from 'react';

import { TaskType, TaskQueryOptionalData } from '@scale/shared-types';
import { SubtaskListItem, TaskListItem } from '@scale/shared/types/corp/task/taskListItem';
import TaskList from 'react-scale/containers/corp/backfills/task/components/TaskList';
import SubtaskList from 'react-scale/containers/corp/backfills/task/components/SubtaskList';
import QueryTasks from 'react-scale/containers/corp/backfills/task/components/QueryTasks';
import QuerySubtasks from 'react-scale/containers/corp/backfills/task/components/QuerySubtasks';
import useLatest from 'react-scale/hooks/useLatest';
import { IAction } from 'react-scale/containers/corp/backfills/task/types';

/*
  Select tasks full component with:
  - project query params
  - UI to select the listed tasks
*/
interface SelectTasksFullProps {
  onChange: (tasks: (TaskListItem | SubtaskListItem)[]) => void;
  onOptDataChange?: (optData: TaskQueryOptionalData) => void;
  disallowedTaskTypes?: TaskType[];
  filterSelectedTasks: any[];
  warning?: string;
  action?: IAction;
  querySubtasks?: boolean;
  setProtectFromCancellingTasks?: (value: boolean) => void;
  lockToProjectId?: string;
}
export const SelectTasksFull: React.FC<SelectTasksFullProps> = ({
  onChange,
  onOptDataChange,
  disallowedTaskTypes,
  filterSelectedTasks = [],
  warning = '',
  action,
  querySubtasks,
  setProtectFromCancellingTasks,
  lockToProjectId,
}) => {
  const [tasks, setTasks] = useState<(TaskListItem | SubtaskListItem)[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedTasks, setSelectedTasks] = useState<(TaskListItem | SubtaskListItem)[]>([]);
  const latestOnChange = useLatest(onChange);

  useEffect(() => {
    latestOnChange.current(selectedTasks);
  }, [latestOnChange, selectedTasks]);

  if (querySubtasks) {
    return (
      <div className="root">
        <QuerySubtasks
          onChange={setTasks}
          disallowedTaskTypes={disallowedTaskTypes}
          setLoading={setLoading}
          warning={warning}
        />
        <SubtaskList
          subtasks={tasks as SubtaskListItem[]}
          onChange={subtasks => setSelectedTasks(subtasks)}
          loading={loading}
        />
      </div>
    );
  }

  return (
    <div className="root">
      <QueryTasks
        onChange={setTasks}
        onOptDataChange={onOptDataChange}
        disallowedTaskTypes={disallowedTaskTypes}
        filterSelectedTasks={filterSelectedTasks}
        setLoading={setLoading}
        warning={warning}
        action={action}
        setProtectFromCancellingTasks={setProtectFromCancellingTasks}
        lockToProjectId={lockToProjectId}
      />
      <TaskList tasks={tasks as TaskListItem[]} onChange={setSelectedTasks} loading={loading} />
    </div>
  );
};

export default SelectTasksFull;
